import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./container/app/app";
import { I18nextProvider } from "react-i18next";
import i18n from "../src/translations"; // Ensure this path is correct
import { Provider } from "react-redux";
import store from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "react-phone-number-input/style.css";
import "../src/assets/scss/style.scss";
import "../src/assets/scss/DatePicker/datepicker.scss";
import { sentryInit } from "./system/sentry";
import ReactGA from "react-ga4";

const root = ReactDOM.createRoot(document.getElementById("root"));
sentryInit();

// Initialize Google Analytics
ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID);

root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      {/* <StrictMode> */}
      <App />
      <ToastContainer />
      {/* </StrictMode> */}
    </I18nextProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
